/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

export type AdminV1OrganizationsPlayerDataByProfileIdRetrieveFormat = typeof AdminV1OrganizationsPlayerDataByProfileIdRetrieveFormat[keyof typeof AdminV1OrganizationsPlayerDataByProfileIdRetrieveFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminV1OrganizationsPlayerDataByProfileIdRetrieveFormat = {
  csv: 'csv',
  json: 'json',
} as const;
